import { AppStore } from './app-store';
import { NotificationStore } from './notification-store';

export class Store {
  appStore: AppStore = new AppStore();
  notificationStore: NotificationStore = new NotificationStore();
}

export const store = new Store();
